import './Style.css';
import React from 'react';

interface ShareHeaderActionsProps {
  onClick: () => void;
  text: string;
  icon: React.ReactNode;
  title?: string;
}

export default function ShareHeaderActions({
  onClick,
  text,
  icon,
  title,
}: ShareHeaderActionsProps) {
  return (
    <button
      onClick={onClick}
      className='btn btn--chip share-header__alerts-btn cursor-pointer'
      aria-label={text}
      title={title || text}
    >
      {icon}
      {text}
    </button>
  );
}
